/**
 * Key family for the PPJK's Pernyataan configs, so a change on Master ›
 * Pernyataan refreshes an open draft's switcher.
 */
export const statementConfigKeys = {
  all: ['statement-configs'] as const,
  mine: () => ['statement-configs', 'mine'] as const,
};
